<template>
    <div>
        <div class="mb-3">
            <BackButton :href="$route('users.invitations')" :to="__('navigation.invitations')"/>
        </div>

        <div class="alert alert-custom" role="alert"
             :class="{'alert-success': wasAccepted, 'alert-light-primary': !wasAccepted}">
            <div class="alert-icon">
                <i v-if="wasAccepted" class="fas fa-check-circle"/>
                <i v-else class="fas fa-clock"/>
            </div>
            <div class="alert-text">
                <div v-if="wasAccepted" class="d-flex flex-row">
                    <div class="flex-grow-1 text-lg d-flex flex-column justify-content-center">
                        <span>Diese Einladung wurde von <b>{{ invitation.user.name }}</b> (<span class="text-lowercase">{{
                                invitation.user.email
                            }}</span>) angenommen</span>
                    </div>
                    <div v-if="Permission.MORPH_TO_USER" class="d-flex flex-column justify-content-center">
                        <Link as="button"
                              :href="$route('user.morph', {user: invitation.user.url_key})"
                              class="btn btn-outline-secondary btn-hover-white text-white">
                            <i class="fas fa-sign-in-alt text-white"/>
                            Login
                        </Link>
                    </div>
                </div>
                <div v-else class="d-flex flex-row">
                    <div class="flex-grow-1">
                        <div class="text-lg font-weight-bold">Diese Einladung wurde bisher nicht angenommen</div>
                        <table class="mt-3">
                            <tr>
                                <td class="font-weight-bold text-center"><i class="fas fa-user-cog"/></td>
                                <td class="pl-2">{{ roles[invitation.role_id] }}</td>
                            </tr>
                            <tr>
                                <td class="font-weight-bold text-center"><i class="fas fa-at"/></td>
                                <td class="pl-2"><a :href="`mailto:${invitation.email}`">{{ invitation.email }}</a></td>
                            </tr>
                            <tr>
                                <td class="font-weight-bold text-center"><i class="fas fa-phone"/></td>
                                <td class="pl-2">{{ invitation.phone || 'Keine Angabe' }}</td>
                            </tr>
                        </table>
                    </div>
                    <div class="d-flex flex-column justify-content-center">
                        <Link as="button"
                              :href="$route('users.invitations.resend', {invitation: invitation.id})"
                              method="POST"
                              class="btn btn-sm btn-outline-primary">
                            <i class="fas fa-paper-plane"/>
                            Einladung erneut senden
                        </Link>
                    </div>
                </div>
            </div>
        </div>

        <div class="card card-body mb-3">
            <table v-if="invitation.stores.length > 0" class="table table-hover">
                <thead>
                <tr>
                    <td>{{ __('general.store') }}</td>
                    <td>{{ __('general.city') }}</td>
                    <td>{{ __('general.street') }}</td>
                    <td class="text-center">{{ __('general.plan') }}</td>
                    <td class="text-center">{{ __('general.role') }}</td>
                    <td class="text-right">{{ __('general.actions') }}</td>
                </tr>
                </thead>
                <tbody>
                <tr v-for="store in invitation.stores">
                    <td>{{ store.name }}</td>
                    <td>{{ store.city || '' }}</td>
                    <td>{{ store.street || '' }}</td>
                    <td class="text-center">{{ store.plan || '' }}</td>
                    <td class="text-center">{{ store.store_role }}</td>
                    <td class="text-right">
                        <a :href="$route('store.edit', {storeUuid: store.store_uuid})"
                           v-if="can(StorePermission.EDIT_BASIC, store.store_uuid)">
                            <i class="fas fa-pen"/> Bearbeiten
                        </a>
                    </td>
                </tr>
                </tbody>
            </table>
            <div v-else>
                <span class="text-muted">Mit dieser Einladung wurden kein Geschäft verknüpft.</span>
            </div>
        </div>

        <div class="p-3 text-center text-muted">
            <span>Erstellt von <b>{{ invitation.agent.name }}</b> am <b>{{
                    $localDate(invitation.created_at)
                }}</b> um <b>{{ $localTime(invitation.created_at) }} Uhr</b>.</span>
            <div v-if="!wasAccepted">
                <span v-if="expireDays > 0">Die Einladung läuft in {{ expireDays }} Tagen ab.</span>
                <span v-else>Die Einladung ist abgelaufen.</span>
            </div>
        </div>

        <!--        <div class="card card-body mt-3">-->
        <!--            <pre>{{ invitation }}</pre>-->
        <!--        </div>-->
    </div>
</template>

<script>
import BackButton from "@components/BackButton.vue";
import {Link} from '@inertiajs/vue2';
import {Permission, StorePermission} from '@js/permissions'
import {can} from '@js/permission-methods'

export default {
    methods: {can},
    components: {BackButton, Link},

    props: {
        invitation: Object,
        roles: Object,
        expireDays: Number,
    },

    computed: {
        StorePermission() {
            return StorePermission
        },
        Permission() {
            return Permission
        },
        wasAccepted() {
            return this.invitation.user_id !== null
        },
    },
}
</script>
